<template>
  <div>
    <el-popover placement="left-start" width="226" trigger="hover">
      <h5>咨询商务人员</h5>
      <hr />
      <h6>{{call.title}}</h6>

      <div v-for="(item, index) in call.data" :key="index">
        <div class>
          <span>{{item.name}}：</span>
          <span>{{item.phone}}</span>
        </div>
      </div>
      <div class="call" slot="reference"></div>
    </el-popover>
  </div>
</template>
<script>
export default {
  data () {
    return {
      call: {
        title: '电话（微信同号）',
        data: [
          { 'name': '付经理', 'phone': 13971292056 }]
      }
    }
  }
}
</script>

<style scoped>
h5 {
  font-size: 16px;
  font-weight: bold;
  color: rgba(74, 17, 118, 1);
  margin-top: 10px;
  margin-bottom: 18px;
  background-image: url(../../assets/images/lxwm_icon.png);
  background-position: center;
  background-repeat: no-repeat;
}
h6 {
  height: 17px;
  font-size: 16px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  margin-top: 10px;
  margin-bottom: 12px;
}
hr {
  width: 200px;
  height: 1px;
  background: rgba(222, 208, 233, 1);
}
div {
  font-size: 14px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}
.call {
  background-image: url(../../assets/images/lxwm_p.png);
  background-position: center;
  background-repeat: no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/popover.vue